import { render, staticRenderFns } from "./BusinessChance.vue?vue&type=template&id=0528cf04"
import script from "./BusinessChance.vue?vue&type=script&lang=js"
export * from "./BusinessChance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports